import Vue from "vue";
import store from "@/app/app-state";
import RestClient from "./restClient";
import { apiUrls } from "@/environment/environment";

const authHelper = class {
  async getAuthTokenFromApi(userinfo) {
    let authAPI = apiUrls.auth;
    this.restClient = new RestClient(authAPI).Instance;
    await this.restClient
      .post(`/Users/Authenticate?companyCode=${userinfo.company}&warehouseCode=${userinfo.warehouse}`, userinfo)
      .then(response => {
        if (response.status == 200) {
          let authToken = response.data;
          Vue.$cookies.set("authToken", authToken.accessToken, new Date(authToken.expiresOn * 1000));
          store.commit("userContext/authToken", authToken.accessToken);
          store.commit("userContext/currentCompany", userinfo.company);
          store.commit("userContext/currentWarehouse", userinfo.warehouse);
        }
      })
      .catch(error => {
        Vue.$log.error(error);
      });
  }

  /**
   * Auto login with key params
   * @param {*} queryInfo
   */
  async getAuthTokenFromApiWithKey(queryInfo) {
    let authAPI = apiUrls.auth;
    this.restClient = new RestClient(authAPI).Instance;
    await this.restClient
      .get(
        `/Users/AuthenticateWithKeyAsync?companyCode=${queryInfo.companyCode}&warehouseCode=${queryInfo.warehouseCode}&key=${queryInfo.key}`
      )
      .then(response => {
        if (response.status == 200) {
          let authToken = response.data;
          Vue.$cookies.set("authToken", authToken.accessToken, new Date(authToken.expiresOn * 1000));
          store.commit("userContext/authToken", authToken.accessToken);
          store.commit("userContext/currentCompany", queryInfo.companyCode);
          store.commit("userContext/currentWarehouse", queryInfo.warehouseCode);
        }
      })
      .catch(error => {
        Vue.$log.error(error);
      });
  }
};

export default new authHelper();
